(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairImportVisitorsModalController', VirtualFairImportVisitorsModalController)

        VirtualFairImportVisitorsModalController.$inject = ['API_BASE', '$uibModalInstance', 'virtualFair', 'getByFilter', '$scope', 'FileUploader', 'toastr'];

    function VirtualFairImportVisitorsModalController(API_BASE, $uibModalInstance, virtualFair, getByFilter, $scope, FileUploader, toastr) {
        var vm = this;

        vm.virtualFair = virtualFair
        vm.getByFilter = getByFilter;

        vm.ok     = ok;
        vm.cancel = cancel;


        activate();


        function activate() {
            $scope.uploader = new FileUploader({
                url: API_BASE + '/virtualfairs/import-general-visitors',
                withCredentials: false,
                method: 'POST',
                formData: [
                    {
                        'virtual_fair_id': vm.virtualFair.id
                    }
                ],
                headers: {
                    'Authorization': 'Bearer ' +  localStorage.getItem('id_token')
                },
                removeAfterUpload: false,
                onCompleteItem: function(fileItem, response, status, headers) {
                    $uibModalInstance.close();
                    vm.getByFilter();
                }
            });
        }


        function ok() {
            $uibModalInstance.close();
        }


        function cancel() {
            $uibModalInstance.close();
        }
    }

})();
